var a = [
  {
    id: 8307756,
    name: 'Pune, India',
    url: 'https://www.roadgoat.com/travel-guides/pune-india',
    image:
      'https://images.unsplash.com/photo-1570356811230-2f3b816ebb29?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80',
    description:
      'Pune, also called Poona, city, west-central Maharashtra state, western India, at the junction of the Mula and Mutha rivers. Called “Queen of the Deccan,” Pune is the cultural capital of the Maratha peoples.',
    stars: 5,
  },
  {
    id: 8319562,
    name: 'Chandigarh, India',
    url: 'https://www.roadgoat.com/travel-guides/chandigarh-india',
    image: 'https://www.holidify.com/images/compressed/545.jpg?v=1.1',
    description:
      "Chandigarh city is the capital of the territory and of the states of Haryana and Punjab. Chandigarh's name, meaning “stronghold of the goddess Chandi,” is derived from the Chandi Mandir, a temple dedicated to the goddess that is located near the town of Mani Majra. ",
    stars: 5,
  },

  {
    id: 8307891,
    name: 'Puducherry, India',
    url: 'https://www.roadgoat.com/travel-guides/puducherry-india',
    image: 'https://www.ibef.org/assets/images/states/Puducherry-2.jpg',
    description:
      'Puducherry, also called Pondicherry, city, capital of Puducherry union territory, southeastern India. The city constitutes an enclave surrounded by Tamil Nadu state, on the Coromandel Coast of the Bay of Bengal, 105 miles (170 km) south of Chennai (Madras).',
    stars: 5,
  },
  {
    id: 8305419,
    name: 'Shimla, India',
    url: 'https://www.roadgoat.com/travel-guides/shimla-india',
    image: 'https://www.toshaliresort.com/helpers/images/the-ridge-shimla.jpg',
    description:
      "Shimla is a beautiful Hill station in the lap of Himachal Pradesh and is also its capital. It is located at an altitude of 2213 m. Shimla derives its name from goddess 'Shayamla Devi' , another form of Goddess Kali. Shimla has been blessed with natural beauty and is surrounded by green pastures and snow-capped peaks.",
    stars: 5,
  },
  {
    id: 8322604,
    name: 'Mumbai, India',
    url: 'https://www.roadgoat.com/travel-guides/mumbai-india',
    image:
      'https://cdn.roadgoat.com/uploads/photo/image/468/large_travel-guide-of-mumbai-india-original.jpg',
    description:
      'Mumbai, previously known as Bombay is one of the most populous and biggest cities of Maharashtra. Also the biggest metropolis of this state, Mumbai is also popular as the entertainment and financial capital. It is the largest city of India and fondly called as the city of dreams.',
    stars: 4.1,
  },

  {
    id: 8311382,
    name: 'Manāli, India',
    url: 'https://www.roadgoat.com/travel-guides/manali-india',
    image:
      'https://www.tripsavvy.com/thmb/zyqX35L3rgFRuVrbGioDKoqPezc=/2121x1414/filters:fill(auto,1)/GettyImages-930881934-5ae56fe48023b90036464e72.jpg',
    description:
      'A gift of the Himalayas to the world, Manali is a beautiful township nestled in the picturesque Beas River valley. It is a rustic enclave known for its cool climate and snow-capped mountains, offering respite to tourists escaping scorching heat of the plains.',
    stars: 4.5,
  },
];

export default a;
